import script from "./home.vue?vue&type=script&setup=true&lang=ts"
export * from "./home.vue?vue&type=script&setup=true&lang=ts"

import "./home.vue?vue&type=style&index=0&id=2d469525&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d469525"]])

export default __exports__